/**
 * CSV export utility. UTF-8 BOM prepended so Excel opens files with
 * em-dashes / arrows / non-ASCII characters intact.
 */
export function downloadCsv(filename: string, rows: Array<Record<string, unknown>>) {
  if (rows.length === 0) return;
  const cols = Object.keys(rows[0]);
  const body = [
    cols.join(","),
    ...rows.map((r) =>
      cols
        .map((c) => {
          const v = r[c];
          if (v == null) return "";
          const s = String(v);
          // RFC 4180 quote-escaping
          return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(","),
    ),
  ].join("\r\n");
  const blob = new Blob(["﻿" + body], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Format a number for the UI — integer + thousands separator. */
export function fmtNum(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return Math.round(n).toLocaleString();
}

/** Format days-of-stock — ∞ for zero-burn SKUs. */
export function fmtDays(d: number | null | undefined): string {
  if (d == null) return "—";
  if (!Number.isFinite(d)) return "∞";
  return Math.round(d).toString();
}
